import { EnhancedCampaign } from '~/components/casino-shared/types';
import { BANNER_HEIGHTS } from '../config';

const getBannerHeight = (banners: EnhancedCampaign[]) => {
	if (banners?.length === 0) {
		return {
			heightMobile: 0,
			heightDesktop: 0
		};
	}

	const isShortLayoutForced = !!banners.find(i => i.mobileLayoutType === 'SHORT');

	return {
		heightMobile: isShortLayoutForced ? BANNER_HEIGHTS.mobileShort : BANNER_HEIGHTS.mobile,
		heightDesktop: BANNER_HEIGHTS.desktop
	};
};

export default getBannerHeight;
